import {
    Checkbox,
    makeStyles,
    TableHead as MUITableHead
} from "@material-ui/core";
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { styledBy } from "../../../../utils/styles";
import TableCell from './TableCell';
import TableRow from './TableRow';


const useStyle = makeStyles((theme) => ({
    tableCell: {
        paddingLeft: 20,
        textTransform: "capitalize",
    },
    root: {
        backgroundColor: styledBy("ascent", theme.palette.ascents)
    },
}))

const TableHead = ({
    align,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort = () => { },
    cols = {},
    hideActions = false,
    hideSelect = false,
    ascent = "baseDark",
    ...props
}) => {

    const classes = useStyle({ ascent });


    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };


    const Cell = (each) => {

        var col = cols[each];

        return (
            <TableCell
                align={align}
                key={col.id}
                style={col.hidden ? { display: "none" } : undefined}
                sortDirection={orderBy === col.id ? order : false}
                className={clsx(`head`, classes.tableCell)}
                color="primary"
                ascent={ascent}
            >
                {col.label}
            </TableCell>
        )
    }


    // const Cell = (each) => {

    //     var col = cols[each];
    //     if(col && col.nestedJSON){
    //         return Cell(col.nestedJSON)
    //     }
    //     return (
    //         <TableCell
    //             align={align}
    //             key={col.id}
    //             sortDirection={orderBy === col.id ? order : false}
    //             className={clsx(`head`, classes.tableCell)}
    //             color="white"
    //             ascent="primary"
    //         >
    //             {col.label}
    //         </TableCell>
    //     )
    // }

    const recursivelyRenderCells = (cols) => {
        return Object.keys(cols).map(Cell);
    }


    return (
        <MUITableHead className={classes.root}>
            <TableRow ascent={'baseDark'} {...props}>
                {(!hideSelect) && <TableCell>
                    <Checkbox
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        color="primary"
                        size="small"
                    />
                </TableCell>}
                {Object.keys(cols).map(Cell)}
                {
                    (!hideActions) && (
                        <TableCell color="primary">
                            Actions
                        </TableCell>
                    )
                }
            </TableRow>
        </MUITableHead>
    );
};

TableHead.propTypes = {
    cols: PropTypes.objectOf(PropTypes.object),
};

export default TableHead;